export default __webpack_public_path__ + "static/media/Gambia.6103d995.png";